import React, { useCallback, useMemo } from 'react';
import style from './ExtraPaymentTypes.module.scss';
import ExtraPaymentTypeIdField from './components/ExtraPaymentTypeField';
import { IExtraPaymentType } from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/editRestaurantState/editRestaurantContext';
import Text from 'components/Text/Text';
import Button from 'components/Button/Button';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { CardBrands } from 'types/customers';

interface IProps {
	extraPaymentTypes: IExtraPaymentType[];
	addExtraPaymentType: (value: IExtraPaymentType) => void;
	changeExtraPaymentTypes: (id: string, value: IExtraPaymentType) => void;
	deleteExtraPaymentType: (value: string) => void;
}

const ExtraPaymentTypes: React.FC<IProps> = ({
	extraPaymentTypes,
	addExtraPaymentType,
	changeExtraPaymentTypes,
	deleteExtraPaymentType,
}) => {
	const handleClick = useCallback(() => {
		const newExtraPaymentType: IExtraPaymentType = {
			id: String(extraPaymentTypes.length + 1),
			brand: null,
			paymentTypeId: null,
		};

		addExtraPaymentType(newExtraPaymentType);
	}, [addExtraPaymentType, extraPaymentTypes]);

	const selectedCardBrands = useMemo(() => {
		return extraPaymentTypes.map((el) => el.brand).filter((el) => el !== null);
	}, [changeExtraPaymentTypes]);

	const isAddDisabled = useMemo<boolean>(
		() => Object.keys(CardBrands).length === extraPaymentTypes.length,
		[selectedCardBrands],
	);

	return (
		<div>
			<div className={style.fieldsContainer}>
				{extraPaymentTypes.map((el) => (
					<ExtraPaymentTypeIdField
						key={el.id}
						extraPaymentType={el}
						selectedCardBrands={selectedCardBrands}
						changeExtraPaymentType={changeExtraPaymentTypes}
						deleteExtraPaymentType={deleteExtraPaymentType}
					/>
				))}
			</div>
			<Button
				className={style.button}
				onClick={handleClick}
				disabled={isAddDisabled}
				iconPosition="post"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#plus`} />
					</svg>
				}
				data-test="addExtraPaymentTypeButton">
				<Text translationNameSpace="form" translationKey="addButton" asFragment={true} />
			</Button>
		</div>
	);
};

export default React.memo(ExtraPaymentTypes);
